'use strict';

/**
 *
 * @name: transObject
 *
 */

function TransObjectFactory(
  $rootScope,
  $http,
  $location,
  $q,
  apiPostService
) {

  'ngInject';

  function calendarDate(post, noYear, noWeekday) {

    if (post.publishDate === null) {

      post.calendarDate = 'Not published (preview)';
      post.publishDateSimple = '2010-02-25';
    } else if ($rootScope.lang === 'en-us' || $rootScope.lang === 'zh-hk') {

      var date = (post.type === 'playlist' || post.type === 'memberPlaylist') ? post.createdAt : post.publishDate;
      post.calendar = moment(date).calendar();
      post.calendar = post.calendar.match(/^[a-zA-Z]/) ? post.calendar.concat(', ') : '';

      if (noWeekday) {

        post.calendarDate = moment(date).format('MMMM D');
      } else if (noYear) {

        post.calendarDate = moment(date).format('[' + post.calendar + ']MMMM D');
      } else {

        post.calendarDate = moment(date).format('[' + post.calendar + ']MMMM D, YYYY');
      }

      post.publishDateSimple = moment(date).format('YYYY-MM-D');
    } else if ($rootScope.lang === 'zh-cn') {

      post.calendar = moment(post.publishDate).calendar();
      /* jshint expr: true */
      post.calendar.match(/^[a-zA-Z]/) ? post.calendar = post.calendar.concat(', ') : post.calendar = '';

      if (noWeekday) {

        post.calendarDate = moment(post.publishDate).format('MM[月]Do[日]');
      } else if (noYear) {

        post.calendarDate = moment(post.publishDate).format('[' + post.calendar + ']MM[月]Do[日]');
      } else {

        post.calendarDate = moment(post.publishDate).format('[' + post.calendar + ']YYYY[年]MM[月]Do[日]');

      }

      post.publishDateSimple = moment(post.publishDate).format('YYYY-MM-D');
    }

    return post;
  }

  function getDuration(post) {

    if ((post.type === 'video' || post.type === 'playlist' || post.type === 'memberPlaylist') &&
      post.contentDuration &&
      !isNaN(post.contentDuration)) {

      var seconds = Math.round(post.contentDuration / 1000);
      var hours = Math.floor(seconds / 3600);
      var remainingSecondsInHour = seconds % 3600;
      var minutes = Math.floor(remainingSecondsInHour / 60);
      var remainingSecondsInMinute = remainingSecondsInHour % 60;

      if (minutes < 10) {

        minutes = '0' + minutes;
      }

      if (remainingSecondsInMinute < 10) {

        remainingSecondsInMinute = '0' + remainingSecondsInMinute;
      }

      post.contentDurationHR = (hours > 0 ? hours + ':' : '') + minutes + ':' + remainingSecondsInMinute;
    } else {

      post.contentDurationHR = null;
    }
  }

  function isPublished(post) {

    if (post.publishDate) {

      var unixPublishDate = moment(post.publishDate).unix();
      var timeNow = moment().unix();

      post.published = (unixPublishDate <= timeNow);
    }
    return post;
  }

  function myAss(post) {

    var deferred = $q.defer();

    if (post.translations[$rootScope.lang].showAssociatedPosts) {

      if (!post.postAssociations || !post.postAssociations.length) {

        post.postAssociations = [];

        apiPostService
          .getPost(post.categoryId, 'random desc', 1, 5)
          .then(function(res) {

            var wootIndex = 0;

            res.data.items.forEach(function(item) {

              if (item.id !== post.id) {

                translateArrayToObject(item);
                getDuration(item);
                trueSlug(item);
                setBookmark(item);
                var ass = {
                  index: wootIndex,
                  language: $rootScope.lang,
                  post: item
                };
                post.postAssociations.push(ass);
                wootIndex++;
              }
            });

            deferred.resolve(post);
          }, function(err) {

            deferred.reject(err);
          });
      } else if (post.postAssociations && post.postAssociations.length) {

        post.postAssociations.forEach(function(item) {

          translateArrayToObject(item.post);
          getDuration(item.post);
          setBookmark(item.post);
          trueSlug(item.post);
        });

        deferred.resolve(post);
      }
    }
    return deferred.promise;
  }

  function setBookmark(post) {

    if (!post.hasOwnProperty('isBookmarked')) {

      post.isBookmarked = ($rootScope.playlist && $rootScope.playlist.idList && !isNaN($rootScope.playlist.idList[post.id]));
    }

    return post;
  }

  function slugify(str) {

    str = str.replace(/\uFF1A/gi, '-');
    var slug = S(str).latinise().toString().toLowerCase().replace(/[^\u3400-\u9FBFa-zA-Z0-9_\s-]/g, '');
    slug = S(slug).dasherize().toString();

    return slug;
  }

  function runMediaFilenames(myObject) {

    /* jshint loopfunc:true */
    /* jshint shadow:true */

    var files = [
      'coverUrl',
      'imageUrl',
      'socialUrl',
      'thumbnailUrl'
    ];

    if (myObject.meta && myObject.meta.fileNames) {

      for (var i = 0; i < files.length; i++) {

        if (myObject[files[i]] && myObject.meta.fileNames[files[i]] && myObject.meta.fileNames[files[i]][$rootScope.lang]) {

          myObject[files[i]] = myObject.meta.fileNames[files[i]][$rootScope.lang];
        }
      }
    }

    if (myObject.media && myObject.media.length) {

      for (var i = 0; i < myObject.media.length; i++) {

        if (myObject.media[i].type === 'image' && myObject.media[i].translations) {

          myObject.media[i].translations.some(function(item) {

            if (item.language === $rootScope.lang && item.title) {

              myObject.media[i].content = myObject.media[i].content + '/' + slugify(item.title) + '.jpg';
              return true;
            }
            return false;
          });
        }
      }
    }
    return myObject;
  }

  function setCanonicalBySeries(post) {

    if (post && post.series) {

      if (post.series.translations[$rootScope.lang]) {

        $rootScope.canonical = $location.protocol() + '://' + $location.host() + '/series/' + post.series.translations[$rootScope.lang].slug + '/' + post.translations[$rootScope.lang].slug;
      } else if (post.series.translations[0]) {

        $rootScope.canonical = $location.protocol() + '://' + $location.host() + '/series/' + post.series.translations[0].slug + '/' + post.translations[$rootScope.lang].slug;
      }
    }
  }

  function translateArrayToObject(myObject) {

    var transObject = {};

    try {

      myObject.translations.forEach(function(item) {

        transObject[item.language] = item;
      });

      myObject.translations = transObject;
      myObject.overlaySettings = {
        hasPlaylistOverlay: false,
        show: null
      };
      runMediaFilenames(myObject);

      return myObject;
    } catch (e) {

      return myObject;
    }
  }

  function translateCategory(post) {

    if (post.category && post.category.translations) {

      translateArrayToObject(post.category);
    }

    return post;
  }

  function translateMedia(post) {

    if (post.media && post.media.length > 0) {

      post.media.forEach(function(item) {

        if (item.translations) {

          translateArrayToObject(item);
        }
      });
    }

    return post;
  }

  function translateTags(post) {

    if (post.tags) {

      post.tags.forEach(function(item) {

        translateArrayToObject(item);
      });
    }
    return post;
  }

  function trueSlug(data, inModule) {

    if (data.inTag) {
      data.translations[$rootScope.lang].trueSlug = '/topic/' +
        data.inTag.translations[$rootScope.lang].slug + '/' +
        data.translations[$rootScope.lang].slug;

      return data;
    }

    if (data.nownessPicks) {
      data.translations[$rootScope.lang].trueSlug = '/picks/' +
        data.translations[$rootScope.lang].slug

      return data;
    }

    if (inModule && inModule.id) {

      data.translations[$rootScope.lang].trueSlug = '/series/' +
        inModule.translations[$rootScope.lang].slug + '/' +
        data.translations[$rootScope.lang].slug;
    } else if (data.seasons && data.seasons.length && data.seasons[0].translations && data.seasons[0].translations.length) {

      data.translations[$rootScope.lang].trueSlug = '/seasons/' +
        data.seasons[0].translations[0].slug + '/' +
        data.translations[$rootScope.lang].slug;
        return data;
    } else if (data.series) {

      data.translations[$rootScope.lang].trueSlug = '/series/' +
        data.series.translations[0].slug + '/' +
        data.translations[$rootScope.lang].slug;
    } else if (data.translations && !data.roles && (!data._type || (data._type && data._type.match('post'))) && (data.type !== 'playlist') && (data.type !== 'memberPlaylist')) {

      data.translations[$rootScope.lang].trueSlug = 'story/' +
        data.translations[$rootScope.lang].slug;
    } else if ((data._type && data._type.match('playlist')) || data.type === 'playlist' || data.type === 'memberPlaylist') {

      data.translations[$rootScope.lang].trueSlug = '/playlist/' +
        data.id + '/' + data.translations[$rootScope.lang].slug;
    } else if (data.roles || data.displayName) {

      data.translations = {};
      var role;

      if (data.roles && data.roles.length) {

        if (data.roles.indexOf('editor') > -1) {

          role = 'member';
        }
        if (data.roles.indexOf('member') > -1) {

          role = 'member';
        }
        if (data.roles.indexOf('contributor') > -1) {

          role = 'contributor';
        }
        if (data.roles.indexOf('brand') > -1) {

          role = 'brand';
        }
      } else {

        role = 'member';
      }

      data.translations[$rootScope.lang] = {
        trueSlug: '/' + role + '/' + data.id + '/' + data.slug
      };
    }

    return data;

  }

  return {
    calendarDate: calendarDate,
    getDuration: getDuration,
    isPublished: isPublished,
    myAss: myAss,
    setBookmark: setBookmark,
    setCanonicalBySeries: setCanonicalBySeries,
    translate: translateArrayToObject,
    translateCategory: translateCategory,
    translateMedia: translateMedia,
    translateTags: translateTags,
    trueSlug: trueSlug,
  };
}

export default TransObjectFactory;



// WEBPACK FOOTER //
// ./app/components/nn-generic-services/nn-trans-object.factory.js